module.exports = __webpack_public_path__ + "static/media/home_background.ccdf92ad.jpg";